// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3iV8l","buttons":"RemoveExpirationActionButtons_buttons__1F3kt"};